import Typography from "@mui/material/Typography/Typography";
// import Grid from "@mui/material/Grid/Grid";
import React from "react";




const CustomLabelXSmallRegular = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"11px",sm:"12px",md:"12px",lg:"14px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight,
                textAlign:!props.normal && ( props.textAlign || "center"),
                lineHeight:1.2,
                opacity:props.opacity
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}

const CustomLabelSmallRegular = (props) => {
    return (
        <Typography
            className={props.className} 
            sx={{
                fontSize: {xs:"12px",md:"16px",lg:"16px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight,
                textAlign:props.textAlign || props.normal || "center",
                lineHeight:(!props.normal  || props.lineHeight) &&  (props.lineHeight || 1.2),
            }}>
            {props.text}
        </Typography>
    )
}




const CustomLabelSmallMediumRegular = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"18px",md:"18px",lg:"18px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight,
                textAlign:!props.normal && "center",
                lineHeight:1.2
            }}>
            {props.text}
        </Typography>
    )
}



const CustomLabelMediumRegular= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"12px",sm:"15px",md:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight,
                lineHeight:(!props.normal && (1.2)) || props.line,
                textAlign:props.textAlign || (!props.normal && "center") 

            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}
const CustomLabelLargeRegular= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"1.2em",md:"1.2em",lg:"2em"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight
            }}>
            {props.text}
        </Typography>
    )
}






const CustomLabelSmallMedium = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"12px",md:"13px",lg:"15px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}
const CustomLabelMediumMedium= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"1.2em",md:"1.2em",lg:"2em"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight
            }}>
            {props.text}
        </Typography>
    )
}
const CustomLabelLargeMedium= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"1.2em",md:"1.2em",lg:"2em"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight
            }}>
            {props.text}
        </Typography>
    )
}





const CustomLabelXSmallBold = (props) => {
    return (
        <Typography
            sx={{
                fontSize: props.fontSize || {xs:"10px",sm:"12px",md:"16px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                textAlign:props.textAlign
            }}>
            {props.text}
        </Typography>
    )
}


const CustomLabelSmallBold = (props) => {
    return (
        <Typography
            className={props.className}
            sx={{
                fontSize: {xxs:"12px",xs:"14px",sm:"18px",md:"24px",lg:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                ...props.style,
                ...props.sx
            }}>
            {props.text}
        </Typography>
    )
}


const CustomLabelMediumSmallBold = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"22px",sm:"28px",md:"30px",lg:"32px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                textAlign:props.textAlign,
                lineHeight:1.2
            }}>
            {props.text}
        </Typography>
    )
}

const CustomLabelMediumBold= (props) => {
    return (
        <Typography
            component={props.component ? props.component : "h2"}
            sx={{
                fontSize: {xs:"24px",md:"40px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight || 700,
                textAlign:props.textAlign || (!props.normal && "center"),
            }}>
            {props.text}
        </Typography>
    )
}
const CustomLabelLargeBold= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"32px",md:"56px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                lineHeight:1.2,
                textAlign:props.textAlign,
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}



const CustomLabelXXLargeBold= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"57px",md:"104px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                lineHeight:1.2,
                textAlign:props.textAlign,
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}



const CustomLabelRegularLargeMedium = (props) => {
    return (
        <Typography
            component={"h2"}
            sx={{
                fontSize: {xs:"16px",md:"24px",lg:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight,
                textAlign:props.textAlign || (!props.normal && "center") ,
                lineHeight:(!props.normal  || props.lineHeight) &&  (props.lineHeight || 1.2)
            }}>
            {props.text}
        </Typography>
    )
}


const CustomLabelRegularMedium = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"12px",sm:"14px",md:"16px",lg:"16px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight,
                textAlign:!props.textAlign && "center",
                lineHeight:(!props.normal  || props.lineHeight) &&  (props.lineHeight || 1.2)
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}




const CustomLabelXSmallMedium = (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"11px",sm:"12px",md:"13px",lg:"15px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Medium',
                fontWeight:props.fontWeight
            }}>
            {props.text}
        </Typography>
    )
}




const CustomLabelLargeBoldIntro= (props) => {
    return (
        <Typography
            component={"h1"}
            sx={{
                fontSize: {xs:"22px",sm:"32px",md:"32px",lg:"38px",xl:"52px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                lineHeight:1.2,
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}

const CustomLabelLargeBoldIntroHead= (props) => {
    return (
        <Typography
            component={"h1"}
            sx={{
                fontSize: {xs:"22px",sm:"32px",md:"42px",lg:"56px",},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                lineHeight:1.1,
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}




const CustomLabelMediumRegularInto= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"18px",sm:"24px",lg:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight,
                lineHeight:props.lineHeight || (!props.normal && 1.2), 
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}






const CustomLabelLargeBoldRedHat= (props) => {
    return (
        <Typography
            component={"h1"}
            sx={{
                fontSize: {xs:"22px",sm:"32px",md:"32px",lg:"38px",xl:"52px"},
                color: props.color?props.color:'black',
                fontFamily: 'Red Hat Display',
                fontWeight:props.fontWeight,
                lineHeight:1,
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}




const CustomLabelMediumRegularRedHatInto= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"18px",sm:"24px",lg:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'Red Hat Display',
                fontWeight:props.fontWeight,
                lineHeight:!props.normal && 1.2,
                textAlign: props.textAlign || {xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}




const CustomLabelLargeServiceDetailsBold= (props) => {
    return (
        <Typography
            component={props.component ? props.component : ""}
            sx={{
                fontSize: {xs:"20px",sm:"28px",md:"56px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Bold',
                fontWeight:props.fontWeight,
                lineHeight:1.2,
                textAlign:props.textAlign,
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}



const CustomLabelMediumRegularDetailsInto= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"15px",sm:"24px",lg:"24px"},
                color: props.color?props.color:'black',
                fontFamily: 'RedHatDisplay-Regular',
                fontWeight:props.fontWeight,
                lineHeight:!props.normal && 1.2,
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}
        </Typography>
    )
}




const CustomLabelExtraLargeBoldRedHat= (props) => {
    return (
        <Typography
            sx={{
                fontSize: {xs:"22px",sm:"32px",md:"32px",lg:"38px",xl:"80px"},
                color: props.color?props.color:'black',
                fontFamily: 'Red Hat Display',
                fontWeight:props.fontWeight,
                lineHeight:props.lineHeight || 1,
                textAlign:{xs:"center",md:"left"},
                ...props.style
            }}>
            {props.text}
            {props.children}

        </Typography>
    )
}


export {
    CustomLabelSmallRegular,
    CustomLabelMediumRegular,
    CustomLabelLargeRegular,
    CustomLabelSmallMedium,
    CustomLabelMediumMedium,
    CustomLabelLargeMedium,
    CustomLabelSmallBold,
    CustomLabelMediumBold,
    CustomLabelLargeBold,
    CustomLabelXSmallBold,
    CustomLabelSmallMediumRegular,
    CustomLabelRegularMedium,
    CustomLabelXSmallRegular,
    CustomLabelMediumSmallBold,
    CustomLabelRegularLargeMedium,
    CustomLabelXXLargeBold,
    CustomLabelXSmallMedium,
    CustomLabelLargeBoldIntro,
    CustomLabelMediumRegularInto,
    CustomLabelLargeBoldRedHat,
    CustomLabelMediumRegularRedHatInto,
    CustomLabelLargeServiceDetailsBold,
    CustomLabelMediumRegularDetailsInto,
    CustomLabelExtraLargeBoldRedHat,
    CustomLabelLargeBoldIntroHead
}
